var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4L7 9V20H16.2456C17.7895 20 19.2105 18.807 19.4912 17.2982L20.4035 12.2456C20.7368 10.4211 19.5439 9 17.7018 9H12V7C12 5.31579 10.6842 4 9 4L7 9V20H16.2456C17.7895 20 19.2105 18.807 19.4912 17.2982L20.4035 12.2456C20.7368 10.4211 19.5439 9 17.7018 9H12V7C12 5.31579 10.6842 4 9 4ZM9 5C10.2632 5 11 5.73684 11 7V10H17.7018C19.0702 10 19.6667 10.7018 19.4211 12.0702L18.5088 17.1228C18.2982 18.2632 17.4211 19 16.2456 19H8V9.19298L9.92982 4.36842C9.98246 4.26316 10 4.12281 10 4C10 3.45614 9.54386 3 9 3C8.57895 3 8.21053 3.26316 8.07018 3.63158L6 8.80702V21H16.2456C18.2807 21 20.1053 19.4561 20.4737 17.4737L21.386 12.4211C21.8246 9.98246 20.1579 8 17.7018 8H13V7C13 4.75439 11.2456 3 9 3C8.45614 3 8 3.45614 8 4C8 4.54386 8.45614 5 9 5ZM6 8C3.75439 8 2 9.75439 2 12V17C2 19.2456 3.75439 21 6 21H8V8H6ZM6 10V19C4.73684 19 4 18.2632 4 17V12C4 10.7368 4.73684 10 6 10Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb_up.b3fcf13d.svg";
export { ForwardRef as ReactComponent };